import { render, staticRenderFns } from "./EditFlourWeightModal.vue?vue&type=template&id=3bc6e96c&"
import script from "./EditFlourWeightModal.vue?vue&type=script&lang=js&"
export * from "./EditFlourWeightModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports